import { render, staticRenderFns } from "./MeusChamados.vue?vue&type=template&id=c635abd4&scoped=true&"
import script from "./MeusChamados.vue?vue&type=script&lang=js&"
export * from "./MeusChamados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c635abd4",
  null
  
)

export default component.exports